/**
 * Workflow-facing aliases for the shared idempotency key spec.
 *
 * The implementation lives in `../idempotency` because agents and dataset
 * triggers resolve the same spec against their own inputs. These names are kept
 * so existing workflow call sites read naturally.
 */
import {
  IDEMPOTENCY_KEY_STRATEGIES,
  idempotencyValueToKey,
  isIdempotencyKeyStrategy,
  parseIdempotencyKeySpec,
  resolveIdempotencyKey,
} from '../idempotency';
import type {
  IdempotencyKeyCompositeStrategy,
  IdempotencyKeySpec,
  IdempotencyKeyStrategy,
  IdempotencyKeyValueStrategy,
  ParseIdempotencyKeyResult,
  ResolveIdempotencyKeyResult,
} from '../idempotency';

export const WORKFLOW_IDEMPOTENCY_KEY_STRATEGIES = IDEMPOTENCY_KEY_STRATEGIES;

export type WorkflowIdempotencyKeyStrategy = IdempotencyKeyStrategy;
export type WorkflowIdempotencyKeyValueStrategy = IdempotencyKeyValueStrategy;
export type WorkflowIdempotencyKeyCompositeStrategy =
  IdempotencyKeyCompositeStrategy;
export type WorkflowIdempotencyKey = IdempotencyKeySpec;
export type ParseWorkflowIdempotencyKeyResult = ParseIdempotencyKeyResult;
export type ResolveWorkflowIdempotencyKeyResult = ResolveIdempotencyKeyResult;

export const isWorkflowIdempotencyKeyStrategy = isIdempotencyKeyStrategy;
export const parseWorkflowIdempotencyKey = parseIdempotencyKeySpec;
export const workflowIdempotencyValueToKey = idempotencyValueToKey;

/**
 * Resolves the workflow run idempotency key from definition config and run inputs.
 * Returns `{ ok: false }` when the pointer is missing or resolves to null/undefined.
 */
export function resolveWorkflowIdempotencyKey(params: {
  readonly config: WorkflowIdempotencyKey | null;
  readonly inputs: unknown;
}): ResolveWorkflowIdempotencyKeyResult {
  return resolveIdempotencyKey(params);
}
